// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Setting Modal Styles */

.ai-setting-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-in-out;
    padding: 20px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.ai-setting-modal {
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    max-width: 900px;
    width: 95%;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    animation: slideIn 0.3s ease-out;
    overflow: hidden;
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.ai-setting-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    border-bottom: 1px solid #e9ecef;
    background: linear-gradient(135deg, #f5f7fa 0%, #f8f9fb 100%);
}

.ai-setting-modal-header h2 {
    margin: 0;
    color: #2c3e50;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -0.5px;
}

.ai-setting-modal-close {
    background: none;
    border: none;
    font-size: 24px;
    line-height: 1;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.ai-setting-modal-close:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #333;
    transform: rotate(90deg);
}

.ai-setting-modal-content {
    flex: 1;
    overflow-y: auto;
    padding: 28px;
    background-color: #fafbfc;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e0 #f8f9fa;
}

.ai-setting-modal-content::-webkit-scrollbar {
    width: 8px;
}

.ai-setting-modal-content::-webkit-scrollbar-track {
    background: #f8f9fa;
}

.ai-setting-modal-content::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 4px;
}

.ai-setting-modal-content::-webkit-scrollbar-thumb:hover {
    background-color: #a0aec0;
}

.ai-setting-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 20px 28px;
    border-top: 1px solid #e1e5e9;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

/* Modal specific form adjustments */
.ai-setting-modal .ai-setting-form {
    background: white;
    border-radius: 10px;
    padding: 24px;
    margin: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ai-setting-modal .ai-setting-section {
    margin-bottom: 28px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e1e4e8;
}

.ai-setting-modal .ai-setting-section:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.ai-setting-modal .ai-setting-section h3 {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 20px 0;
    padding-left: 14px;
    position: relative;
}

.ai-setting-modal .ai-setting-section h3::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background: #007bff;
    border-radius: 2px;
}

.ai-setting-modal .ai-setting-subsection {
    margin: 20px 0;
    padding: 16px;
    background: #f6f8fa;
    border-radius: 8px;
    border-left: 3px solid #17a2b8;
}

.ai-setting-modal .ai-setting-subsection h4 {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 12px;
}

.ai-setting-modal .ai-setting-field {
    margin-bottom: 20px;
}

.ai-setting-modal .ai-setting-field label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #495057;
}

.ai-setting-modal .ai-setting-field input,
.ai-setting-modal .ai-setting-field select {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.2s ease;
    background-color: #fff;
    box-sizing: border-box;
}

.ai-setting-modal .ai-setting-field input:focus,
.ai-setting-modal .ai-setting-field select:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
}

.ai-setting-modal .ai-setting-field input::placeholder {
    color: #adb5bd;
}

/* Checkbox styling */
.ai-setting-modal .ai-setting-checkbox {
    margin: 20px 0;
}

.ai-setting-modal .ai-setting-checkbox label {
    display: flex;
    align-items: center;
    font-weight: normal;
    cursor: pointer;
    padding: 8px 0;
}

.ai-setting-modal .ai-setting-checkbox input[type="checkbox"] {
    width: auto;
    margin-right: 10px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* Array input styling */
.ai-setting-modal .ai-setting-array-item {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    align-items: center;
}

.ai-setting-modal .ai-setting-array-item input {
    flex: 1;
}

/* Modal specific button styles */
.ai-setting-modal .ai-setting-button {
    min-width: 120px;
    position: relative;
    overflow: hidden;
}

.ai-setting-modal .ai-setting-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent
    );
    transition: left 0.5s;
}

.ai-setting-modal .ai-setting-button:hover::before {
    left: 100%;
}

.ai-setting-modal .ai-setting-button--primary {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    border: none;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.ai-setting-modal .ai-setting-button--primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(79, 70, 229, 0.4);
}

.ai-setting-modal .ai-setting-button--cancel {
    background: transparent;
    border: 2px solid #9ca3af;
    color: #6b7280;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.ai-setting-modal .ai-setting-button--cancel:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #6b7280;
    color: #374151;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(107, 114, 128, 0.2);
}

/* Loading animation for save button */
.ai-setting-modal .ai-setting-button--primary:disabled {
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    position: relative;
    overflow: hidden;
}

.ai-setting-modal .ai-setting-button--primary:disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.5),
        transparent
    );
    animation: loading-shimmer 1.5s infinite;
}

@keyframes loading-shimmer {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .ai-setting-modal {
        max-width: 95%;
        max-height: 95vh;
        margin: 10px;
    }

    .ai-setting-modal-header {
        padding: 16px;
    }

    .ai-setting-modal-header h2 {
        font-size: 18px;
    }

    .ai-setting-modal-content {
        padding: 16px;
    }

    .ai-setting-modal .ai-setting-form {
        padding: 16px;
    }
}

@media (max-width: 480px) {
    .ai-setting-modal {
        max-width: 100%;
        height: 100vh;
        margin: 0;
        border-radius: 0;
    }

    .ai-setting-modal-content {
        padding: 12px;
    }

    .ai-setting-modal-footer {
        flex-direction: column-reverse;
        gap: 8px;
    }

    .ai-setting-modal-footer button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/ai_setting/components/web/ai-setting-modal.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,6DAA6D;AACjE;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,6DAA6D;AACjE;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ;;;;;KAKC;IACD,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,sCAAsC;AACtC;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ;;;;;KAKC;IACD,wCAAwC;AAC5C;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,aAAa;QACb,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* AI Setting Modal Styles */\n\n.ai-setting-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    animation: fadeIn 0.2s ease-in-out;\n    padding: 20px;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.ai-setting-modal {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n    max-width: 900px;\n    width: 95%;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    animation: slideIn 0.3s ease-out;\n    overflow: hidden;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateY(-20px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.ai-setting-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 28px;\n    border-bottom: 1px solid #e9ecef;\n    background: linear-gradient(135deg, #f5f7fa 0%, #f8f9fb 100%);\n}\n\n.ai-setting-modal-header h2 {\n    margin: 0;\n    color: #2c3e50;\n    font-size: 22px;\n    font-weight: 600;\n    letter-spacing: -0.5px;\n}\n\n.ai-setting-modal-close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    line-height: 1;\n    color: #6c757d;\n    cursor: pointer;\n    padding: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n}\n\n.ai-setting-modal-close:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: #333;\n    transform: rotate(90deg);\n}\n\n.ai-setting-modal-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 28px;\n    background-color: #fafbfc;\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e0 #f8f9fa;\n}\n\n.ai-setting-modal-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.ai-setting-modal-content::-webkit-scrollbar-track {\n    background: #f8f9fa;\n}\n\n.ai-setting-modal-content::-webkit-scrollbar-thumb {\n    background-color: #cbd5e0;\n    border-radius: 4px;\n}\n\n.ai-setting-modal-content::-webkit-scrollbar-thumb:hover {\n    background-color: #a0aec0;\n}\n\n.ai-setting-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    padding: 20px 28px;\n    border-top: 1px solid #e1e5e9;\n    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n}\n\n/* Modal specific form adjustments */\n.ai-setting-modal .ai-setting-form {\n    background: white;\n    border-radius: 10px;\n    padding: 24px;\n    margin: 0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.ai-setting-modal .ai-setting-section {\n    margin-bottom: 28px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid #e1e4e8;\n}\n\n.ai-setting-modal .ai-setting-section:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n.ai-setting-modal .ai-setting-section h3 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #2c3e50;\n    margin: 0 0 20px 0;\n    padding-left: 14px;\n    position: relative;\n}\n\n.ai-setting-modal .ai-setting-section h3::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 4px;\n    height: 20px;\n    background: #007bff;\n    border-radius: 2px;\n}\n\n.ai-setting-modal .ai-setting-subsection {\n    margin: 20px 0;\n    padding: 16px;\n    background: #f6f8fa;\n    border-radius: 8px;\n    border-left: 3px solid #17a2b8;\n}\n\n.ai-setting-modal .ai-setting-subsection h4 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 12px;\n}\n\n.ai-setting-modal .ai-setting-field {\n    margin-bottom: 20px;\n}\n\n.ai-setting-modal .ai-setting-field label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #495057;\n}\n\n.ai-setting-modal .ai-setting-field input,\n.ai-setting-modal .ai-setting-field select {\n    width: 100%;\n    padding: 10px 14px;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    background-color: #fff;\n    box-sizing: border-box;\n}\n\n.ai-setting-modal .ai-setting-field input:focus,\n.ai-setting-modal .ai-setting-field select:focus {\n    outline: none;\n    border-color: #80bdff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);\n}\n\n.ai-setting-modal .ai-setting-field input::placeholder {\n    color: #adb5bd;\n}\n\n/* Checkbox styling */\n.ai-setting-modal .ai-setting-checkbox {\n    margin: 20px 0;\n}\n\n.ai-setting-modal .ai-setting-checkbox label {\n    display: flex;\n    align-items: center;\n    font-weight: normal;\n    cursor: pointer;\n    padding: 8px 0;\n}\n\n.ai-setting-modal .ai-setting-checkbox input[type=\"checkbox\"] {\n    width: auto;\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n/* Array input styling */\n.ai-setting-modal .ai-setting-array-item {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n    align-items: center;\n}\n\n.ai-setting-modal .ai-setting-array-item input {\n    flex: 1;\n}\n\n/* Modal specific button styles */\n.ai-setting-modal .ai-setting-button {\n    min-width: 120px;\n    position: relative;\n    overflow: hidden;\n}\n\n.ai-setting-modal .ai-setting-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(255, 255, 255, 0.3),\n        transparent\n    );\n    transition: left 0.5s;\n}\n\n.ai-setting-modal .ai-setting-button:hover::before {\n    left: 100%;\n}\n\n.ai-setting-modal .ai-setting-button--primary {\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    border: none;\n    color: white;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.ai-setting-modal .ai-setting-button--primary:hover:not(:disabled) {\n    background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);\n    transform: translateY(-3px);\n    box-shadow: 0 8px 25px rgba(79, 70, 229, 0.4);\n}\n\n.ai-setting-modal .ai-setting-button--cancel {\n    background: transparent;\n    border: 2px solid #9ca3af;\n    color: #6b7280;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.ai-setting-modal .ai-setting-button--cancel:hover:not(:disabled) {\n    background: #f3f4f6;\n    border-color: #6b7280;\n    color: #374151;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(107, 114, 128, 0.2);\n}\n\n/* Loading animation for save button */\n.ai-setting-modal .ai-setting-button--primary:disabled {\n    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n    position: relative;\n    overflow: hidden;\n}\n\n.ai-setting-modal .ai-setting-button--primary:disabled::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(255, 255, 255, 0.5),\n        transparent\n    );\n    animation: loading-shimmer 1.5s infinite;\n}\n\n@keyframes loading-shimmer {\n    0% {\n        left: -100%;\n    }\n    100% {\n        left: 100%;\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .ai-setting-modal {\n        max-width: 95%;\n        max-height: 95vh;\n        margin: 10px;\n    }\n\n    .ai-setting-modal-header {\n        padding: 16px;\n    }\n\n    .ai-setting-modal-header h2 {\n        font-size: 18px;\n    }\n\n    .ai-setting-modal-content {\n        padding: 16px;\n    }\n\n    .ai-setting-modal .ai-setting-form {\n        padding: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .ai-setting-modal {\n        max-width: 100%;\n        height: 100vh;\n        margin: 0;\n        border-radius: 0;\n    }\n\n    .ai-setting-modal-content {\n        padding: 12px;\n    }\n\n    .ai-setting-modal-footer {\n        flex-direction: column-reverse;\n        gap: 8px;\n    }\n\n    .ai-setting-modal-footer button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
